import { z } from "zod";
import { BladeCommonSchema } from "../common";
export const TickerBannerBladeSchema = BladeCommonSchema.extend({
    title1: z.string(),
    title2: z.string(),
    subtitle: z.string(),
});
export const TickerBannerBladeTypeValues = ["textMarquee"];
export const TickerBannerBladeTypesSchema = z.enum(TickerBannerBladeTypeValues);
export const TickerBannerBladeTypes = TickerBannerBladeTypesSchema.enum;
export const TickerBannerBladesContractSchema = TickerBannerBladeSchema.extend({
    type: TickerBannerBladeTypesSchema,
});
export const TickerBannerContractSchema = TickerBannerBladeSchema.extend({
    type: z.literal(TickerBannerBladeTypes.textMarquee),
});
//# sourceMappingURL=index.js.map